<template>
<div class="chapter">
<div class="inner_page">
<p class="block_7">
</p>
<p class="block_8"> </p>
<p class="block_8"> </p>
<p class="block_8"> </p>
<p class="block_8"> </p>
<h1 class="block_1" id="toc_id_3">Acknowledgement</h1>
<p class="block_8"> </p>
<p class="block_8"> </p>
<p class="block_8"> </p>
<p class="block_9">Cover photograph of author by Dan Porges.</p>
<p class="block_10"> </p>
<p class="block_10"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_002.vue?072fabad